"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppAvailability = void 0;
const zod_1 = require("zod");
class AppAvailability {
    constructor() {
        this.BIOLOGY_PROD_IOS = false;
        this.CHEMISTRY_PROD_IOS = false;
        this.FRENCH_PROD_IOS = false;
        this.LT_DEV_IOS = false;
        this.LT_PROD_IOS = false;
        this.LT_DEV_WEB = false;
        this.LT_PROD_WEB = false;
        this.QUIZ_PROD_WEB = false;
    }
    isEqual(other) {
        return this.BIOLOGY_PROD_IOS === other.BIOLOGY_PROD_IOS &&
            this.CHEMISTRY_PROD_IOS === other.CHEMISTRY_PROD_IOS &&
            this.FRENCH_PROD_IOS === other.FRENCH_PROD_IOS &&
            this.LT_DEV_IOS === other.LT_DEV_IOS &&
            this.LT_DEV_WEB === other.LT_DEV_WEB &&
            this.LT_PROD_WEB === other.LT_PROD_WEB &&
            this.LT_PROD_IOS === other.LT_PROD_IOS &&
            this.QUIZ_PROD_WEB === other.QUIZ_PROD_WEB;
    }
}
exports.AppAvailability = AppAvailability;
AppAvailability.jsonSchema = zod_1.z.object({
    BIOLOGY_PROD_IOS: zod_1.z.boolean(),
    CHEMISTRY_PROD_IOS: zod_1.z.boolean(),
    FRENCH_PROD_IOS: zod_1.z.boolean(),
    LT_DEV_IOS: zod_1.z.boolean(),
    LT_PROD_IOS: zod_1.z.boolean(),
    LT_DEV_WEB: zod_1.z.boolean(),
    LT_PROD_WEB: zod_1.z.boolean(),
    QUIZ_PROD_WEB: zod_1.z.boolean()
});
AppAvailability.converter = {
    toObject(data) {
        return {
            BIOLOGY_PROD_IOS: data.BIOLOGY_PROD_IOS,
            CHEMISTRY_PROD_IOS: data.CHEMISTRY_PROD_IOS,
            FRENCH_PROD_IOS: data.FRENCH_PROD_IOS,
            LT_DEV_IOS: data.LT_DEV_IOS,
            LT_PROD_IOS: data.LT_PROD_IOS,
            LT_DEV_WEB: data.LT_DEV_WEB,
            LT_PROD_WEB: data.LT_PROD_WEB,
            QUIZ_PROD_WEB: data.QUIZ_PROD_WEB
        };
    },
    fromObject(object) {
        const data = new AppAvailability();
        if (typeof object.BIOLOGY_PROD_IOS === "boolean") {
            data.BIOLOGY_PROD_IOS = object.BIOLOGY_PROD_IOS;
        }
        if (typeof object.CHEMISTRY_PROD_IOS === "boolean") {
            data.CHEMISTRY_PROD_IOS = object.CHEMISTRY_PROD_IOS;
        }
        if (typeof object.FRENCH_PROD_IOS === "boolean") {
            data.FRENCH_PROD_IOS = object.FRENCH_PROD_IOS;
        }
        if (typeof object.LT_DEV_IOS === "boolean") {
            data.LT_DEV_IOS = object.LT_DEV_IOS;
        }
        if (typeof object.LT_PROD_IOS === "boolean") {
            data.LT_PROD_IOS = object.LT_PROD_IOS;
        }
        if (typeof object.LT_DEV_WEB === "boolean") {
            data.LT_DEV_WEB = object.LT_DEV_WEB;
        }
        if (typeof object.LT_PROD_WEB === "boolean") {
            data.LT_PROD_WEB = object.LT_PROD_WEB;
        }
        if (typeof object.QUIZ_PROD_WEB === "boolean") {
            data.QUIZ_PROD_WEB = object.QUIZ_PROD_WEB;
        }
        return data;
    }
};
